import React, { useEffect, useState } from 'react';
import { apiFetch } from '../../../apiFetch';
import { useNavigate } from 'react-router-dom';
import './Opportunities.css';

const Opportunities = ({ playerId }) => {
  const [opportunities, setOpportunities] = useState([]);
  const [activeTab, setActiveTab] = useState('All');
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchOpportunities = async () => {
      try {
        console.log('📥 Fetching opportunities for playerId:', playerId);

        const res = await apiFetch(`/api/opportunities-for-player/${playerId}`);

        if (!res.ok) {
          const text = await res.text().catch(() => '');
          throw new Error(`Failed to fetch opportunities (${res.status}): ${text}`);
        }

        const data = await res.json();
        const arr = Array.isArray(data) ? data : [];
        const sorted = arr.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setOpportunities(sorted);
      } catch (err) {
        console.error('❌ Failed to fetch opportunities:', err);
      }
    };

    if (playerId) {
      fetchOpportunities();
    } else {
      console.warn('⚠️ No playerId provided, skipping opportunity fetch.');
    }
  }, [playerId]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && isFullScreen) {
        setIsFullScreen(false);
      }
    };

    window.addEventListener('keydown', handleEsc);

    if (isFullScreen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      window.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [isFullScreen]);

  const handleApplyRedirect = (opportunityId) => {
    navigate(`/apply/${opportunityId}`);
  };

  const tabs = ['All', 'Agent', 'Scout', 'Club'];

  const filteredOpportunities = opportunities.filter(
    (opp) => activeTab === 'All' || opp.source === activeTab
  );

  return (
    <div className={`opportunities-container ${isFullScreen ? 'fullscreen' : ''}`}>
      <div className="opportunities-topbar">
        <h2 className="opportunities-title">Opportunities</h2>

        <div className="opportunities-tabs">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`tab-button ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
              type="button"
            >
              {tab} Opportunities
            </button>
          ))}
        </div>

        <button
          className={`fullscreen-toggle-button ${isFullScreen ? 'is-fullscreen' : 'is-windowed'}`}
          onClick={() => setIsFullScreen((prev) => !prev)}
          aria-label={isFullScreen ? 'Exit full screen' : 'Open full screen'}
          title={isFullScreen ? 'Exit full screen' : 'Open full screen'}
          type="button"
        >
          {isFullScreen ? 'Close Full Screen' : 'Full Screen'}
        </button>
      </div>

      <div className="opportunity-list">
        {filteredOpportunities.length > 0 ? (
          filteredOpportunities.map((opp, index) => (
            <div
              key={opp.id || index}
              className="opportunity-card"
              onClick={() => setSelectedOpportunity(opp)}
            >
              <div className="opportunity-header">
                <span className="source">{opp.source}</span>
                <span className="timestamp">
                  {new Date(opp.createdAt).toLocaleString()}
                </span>
              </div>

              <p className="opportunity-description">{opp.description}</p>

              {opp.link && (
                <a
                  href={opp.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="opportunity-link"
                  onClick={(e) => e.stopPropagation()}
                >
                  View Link
                </a>
              )}

              <button
                className="apply-button"
                onClick={(e) => {
                  e.stopPropagation();
                  handleApplyRedirect(opp.id);
                }}
                type="button"
              >
                Apply
              </button>
            </div>
          ))
        ) : (
          <div className="no-opportunities">
            Posted Opportunities will be shown here.
          </div>
        )}
      </div>

      {selectedOpportunity && (
        <div
          className="opportunity-modal"
          onClick={() => setSelectedOpportunity(null)}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="modal-close"
              onClick={() => setSelectedOpportunity(null)}
              type="button"
            >
              X
            </button>

            <h2>{selectedOpportunity.source} Opportunity</h2>

            <p className="full-description">
              {selectedOpportunity.description}
            </p>

            {selectedOpportunity.link && (
              <a
                href={selectedOpportunity.link}
                target="_blank"
                rel="noopener noreferrer"
                className="opportunity-link"
              >
                View Link
              </a>
            )}

            <button
              className="apply-button"
              onClick={() => handleApplyRedirect(selectedOpportunity.id)}
              type="button"
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Opportunities;












